import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';

const rootStyle = css`
  /* antd sets translate(0) here as a Chrome render fix (tabs/style/index.js:745), which makes the
     wrapper a containing block and pins any fixed-position descendant to it. */
  .ant-tabs-nav-wrap {
    transform: none;
  }

  /* Restores the "grey" variant the audit dropped as unused: it is passed by the brand tab bars of
     every dealer and group configuration page, the campaign details drawer and the follow-up
     template tabs. It makes the bar neutral rather than branded -- without it the tabs lose half
     their width and the active tab and ink bar turn primary blue. */
  &.tabs--neutral {
    .ant-tabs-tab {
      padding: 12px 16px;

      &.ant-tabs-tab-active > .ant-tabs-tab-btn {
        color: ${colors['@text-color']};
      }
    }

    .ant-tabs-ink-bar {
      background-color: ${colors['@text-color-secondary']};
    }
  }

  /* fb-box is the app's global box (ui/_styles/_box.less), not a Tabs variant: on a Tabs the box
     look moves from the root to the panel so card tabs sit on its edge. */
  &.fb-box {
    border: none;
    background-color: transparent;

    .ant-tabs-body {
      padding: 1.5rem;
      background-color: ${colors['@white']};
      border: solid 1px ${colors['@border-color-grey']};
      border-top: none;
      border-radius: 0 4px 4px 4px;
    }
  }
`;

const tabsConfig: ConfigProviderProps['tabs'] = { classNames: { root: rootStyle } };

export default tabsConfig;
